import { GroupIcon } from '../../Brand/Icon';
import React from "react";
import { APP_ROUTES } from '../../../utils/constant';
import SmartBadge from '../../SmartBadge';
import url from '../../../utils/url';
import { AnimatedLink } from '../AnimatedLink';
import { useTranslation } from 'react-i18next';

export default function ButtonFollowers({ username, count }) {
  const { t } = useTranslation();
  return (
      <AnimatedLink aria-label={t('user.followers')} to={url(`${APP_ROUTES.USER}/${username}${APP_ROUTES.USER_FOLLOWERS}`)}>
        <SmartBadge count={count} showZero color="#faad14" size="small" offset={[-24, 32]}>
          <GroupIcon className="nav-icon" />
        </SmartBadge>
      </AnimatedLink>
  )
}
